import EzController from 'controllers/ez-base-controller';
import FacebookLogin from 'lib/facebook-login';
import GoogleLogin from 'lib/google-login';
import { triggerCustomEvent } from 'lib/helpers';
import events from 'lib/events';

export default class SocialSessionButtonsController extends EzController {
  static targets = [
    'fbButton',
    'fbText',
    'googleButton',
    'googleText',
  ];

  connect() {
    this.connectType = this.element.dataset.connectType;

    this.facebook = new FacebookLogin(
      this.fbButtonTarget,
      this.fbTextTarget,
      this.csrfToken,
    );

    this.google = new GoogleLogin(
      this.googleButtonTarget,
      this.googleTextTarget,
      this.csrfToken,
      this.element.dataset.omniauthToken,
    );
  }

  connectFacebook = () => {
    triggerCustomEvent(events.sessions.social[`${this.connectType}_with_facebook`]);

    this.facebook.connect();
  }

  connectGoogle = () => {
    triggerCustomEvent(events.sessions.social[`${this.connectType}_with_google`]);

    this.google.connect();
  }
}
